import React from 'react';
import { Routes } from '../../enums';
import styles from './footer.module.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { name: 'About', href: 'https://developer.mescius.com/about' },
    { name: 'Contact', href: 'https://developer.mescius.com/contact' },
    { name: 'Media Center', href: 'https://developer.mescius.com/about/media-center' },
    { name: 'Privacy', href: 'https://developer.mescius.com/legal/privacy-policy' },
    { name: 'Terms', href: 'https://developer.mescius.com/legal/tos' },
    { name: 'EULA', href: 'https://developer.mescius.com/legal/eula' },
  ];

  return (
    <div className={styles.root}>
      <div className="container">
        <div className="row test">
          <div className={`col-lg-4 ${styles.brand}`}>
            <a href={Routes.GrapeCityHomePage} className={styles.logo}><i className="mesicon-logo-horiz"></i></a>
            <p>&copy;<span id="copyright-year">{currentYear}</span> MESCIUS USA, Inc. All rights reserved.<br />1.800.858.2739</p>
            <p>All product and company names herein may be trademarks of their respective owners.</p>
          </div>
          <div className={`col-lg-2 ${styles.company}`}>
            <ul>
              <li>Company</li>
              {navLinks.map((item) => (
                <li key={item.href}>
                  <a href={item.href}>
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className={`col-lg-2 ${styles.social}`}>
          </div>
          <div className={`col-lg-4 ${styles.subscribe}`}>
            <ul>
              <li>Get the Latest News</li>
              <li>Stay up to date with blogs, eBooks, events, and whitepapers.</li>
              <li><a href="https://developer.mescius.com/subscribe" >Join Now</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
